module.exports = __webpack_public_path__ + "img/ecartpay-white.b2575f01.svg";